(function () {
  const LONDON_API = 'https://worldtimeapi.org/api/timezone/Europe/London';
  const container = document.getElementById('trendymen-countdown');
  const timerEl = document.getElementById('trendymen-countdown-timer');
  const noteEl  = document.getElementById('trendymen-countdown-note');
  const liquidServerTs = container && container.dataset && container.dataset.serverTs ? Number(container.dataset.serverTs) : null;

  function pad(n){ return n < 10 ? '0' + n : String(n); }
function formatDuration(totalSec) {
  if (totalSec < 0) totalSec = 0;

  const days = Math.floor(totalSec / 86400);
  const hrs  = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = Math.floor(totalSec % 60);

  const hStr = `<span class="time-num">${hrs < 10 ? '0' : ''}${hrs}</span><span class="time-unit">h</span>`;
  const mStr = `<span class="time-num">${mins < 10 ? '0' : ''}${mins}</span><span class="time-unit">m</span>`;
  const sStr = `<span class="time-num">${secs < 10 ? '0' : ''}${secs}</span><span class="time-unit">s</span>`;

  if (days > 0) {
    const dStr = `<span class="time-num">${days}</span><span class="time-unit">d</span>`;
    return `${dStr} ${hStr} ${mStr} ${sStr}`;
  } else {
    return `${hStr} ${mStr} ${sStr}`;
  }
}



  // Convert London wall time to instant using an authoritative reference instant & its wall parts
  function londonWallToInstantUsingReference(refInstantMs, refParts, y,m,d,h=0,min=0,s=0) {
    const referenceUtcMillis = Date.UTC(refParts.year, refParts.month - 1, refParts.day, refParts.hour, refParts.minute, refParts.second);
    const tzOffsetMs = referenceUtcMillis - refInstantMs;
    return new Date(Date.UTC(y, m - 1, d, h, min, s) - tzOffsetMs);
  }

  // Compute the target given a reference London instant (ms) and its wall parts
  function computeTargetFromLondon(refInstantMs, refParts) {
    const toInstant = (yy,mm,dd,hh=0,mi=0,ss=0) => londonWallToInstantUsingReference(refInstantMs, refParts, yy,mm,dd,hh,mi,ss);

    // Determine Monday date for the London calendar week
    const calendarUtc = new Date(Date.UTC(refParts.year, refParts.month - 1, refParts.day));
    const weekday = calendarUtc.getUTCDay(); // 0 Sun .. 1 Mon .. 6 Sat
    const daysSinceMon = (weekday + 6) % 7;
    const mondayDay = refParts.day - daysSinceMon;

    const monday15 = toInstant(refParts.year, refParts.month, mondayDay, 15,0,0);
    const friday15 = toInstant(refParts.year, refParts.month, mondayDay + 4, 15,0,0);
    const nowMs = refInstantMs;

    if (nowMs >= monday15.getTime() && nowMs < friday15.getTime()) {

      // Add weekday class
      container.classList.remove('trendymen-weekend');
      container.classList.add('trendymen-weekday');


      // DAILY ROLLING WINDOW (Mon 15:00 up to Fri 15:00)
      // Find the next occurrence of 15:00 London that is strictly AFTER now:
      // - if London wall-hour < 15 => today at 15:00
      // - else => tomorrow at 15:00
      // Use refParts' London wall-hour to decide.
      const curHour = refParts.hour;
      const curDay = refParts.day;
      const curMonth = refParts.month;
      const curYear = refParts.year;

      if (curHour < 15 || (curHour === 15 && (refParts.minute === 0 && refParts.second === 0 && nowMs < monday15.getTime()))) {
        // target = today 15:00
        const target = toInstant(curYear, curMonth, curDay, 15, 0, 0);
        // If that instant is <= now (edge case), pick tomorrow
        if (target.getTime() <= nowMs) {
          const tomorrow = toInstant(curYear, curMonth, curDay + 1, 15, 0, 0);
          return { target: tomorrow, note: 'for same-day dispatch (Mon - Fri)' };
        }
        return { target: target, note: 'for same-day dispatch (Mon - Fri)' };
      } else {
        // target = tomorrow 15:00
        const target = toInstant(curYear, curMonth, curDay + 1, 15, 0, 0);
        return { target: target, note: 'for same-day dispatch (Mon - Fri)' };
      }
    } else {
      // Add weekend class
      container.classList.remove('trendymen-weekday');
      container.classList.add('trendymen-weekend');

      // FRIDAY 15:00 -> MONDAY 15:00 window (or earlier than Monday 15:00)
      let pickMonday = mondayDay;
      if (nowMs >= friday15.getTime()) pickMonday = mondayDay + 7; // next week's Monday
      const target = toInstant(refParts.year, refParts.month, pickMonday, 15, 0, 0);
      return { target, note: 'for same-day dispatch (Mon - Fri)' };

      // FRIDAY 15:00 -> TUESDAY 15:00 (bank holiday adjustment). After bank holiday, comment the below and un-comment the above.
      // let pickTuesday = mondayDay + 1; // Tuesday of current week
      // if (nowMs >= friday15.getTime()) pickTuesday = mondayDay + 8; // next week's Tuesday
      // const target = toInstant(refParts.year, refParts.month, pickTuesday, 15, 0, 0);
      // return { target, note: 'for same-day dispatch (Mon - Fri)' };


    }
  }

  // Fetch worldtimeapi and return { ms, parts }
  function fetchLondonNow() {
    return fetch(LONDON_API, { cache: 'no-store' })
      .then(r => { if (!r.ok) throw new Error('time api ' + r.status); return r.json(); })
      .then(json => {
        const instant = new Date(json.datetime);
        const ms = instant.getTime();
        const fmt = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric',
          hour12: false
        });
        const partsObj = fmt.formatToParts(instant).reduce((acc,p) => { if (p.type !== 'literal') acc[p.type] = Number(p.value); return acc; }, {});
        return { ms, parts: {
          year: partsObj.year, month: partsObj.month, day: partsObj.day,
          hour: partsObj.hour, minute: partsObj.minute, second: partsObj.second
        } };
      });
  }

  function deriveLondonPartsFromInstant(ms) {
    const instant = new Date(ms);
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false
    });
    const partsObj = fmt.formatToParts(instant).reduce((acc,p) => { if (p.type !== 'literal') acc[p.type] = Number(p.value); return acc; }, {});
    return { year: partsObj.year, month: partsObj.month, day: partsObj.day,
             hour: partsObj.hour, minute: partsObj.minute, second: partsObj.second };
  }

  // Start countdown given reference instant & parts
  function startCountdown(refInstantMs, refParts) {
    let current = computeTargetFromLondon(refInstantMs, refParts);

    // baselines to advance authoritative time locally
    const baselineServerRef = { value: refInstantMs };
    const baselineClientRef = { value: Date.now() };

    function authoritativeNow() {
      return new Date(baselineServerRef.value + (Date.now() - baselineClientRef.value));
    }

    // On crossing a target we refresh authoritative London time (rare)
    let refreshing = false;
    function tick() {
      const now = authoritativeNow();
      if (now.getTime() >= current.target.getTime() && !refreshing) {
        refreshing = true;
        fetchLondonNow().then(data => {
          baselineServerRef.value = data.ms;
          baselineClientRef.value = Date.now();
          current = computeTargetFromLondon(data.ms, data.parts);
        }).catch(() => {
          // fallback: recompute using derived parts from now
          const parts = deriveLondonPartsFromInstant(now.getTime());
          current = computeTargetFromLondon(now.getTime(), parts);
        }).finally(() => { refreshing = false; });
        return;
      }

      const diffSec = Math.floor((current.target.getTime() - now.getTime()) / 1000);
      if (timerEl) timerEl.innerHTML = formatDuration(diffSec);
      
      if (noteEl) noteEl.textContent = current.note;
    }

    tick();
    setInterval(tick, 1000);
  }

  // Init: try worldtimeapi -> liquid fallback -> client Intl fallback
  fetchLondonNow().then(data => {
    startCountdown(data.ms, data.parts);
  }).catch(() => {
    if (liquidServerTs && !isNaN(liquidServerTs)) {
      const ms = liquidServerTs * 1000;
      const parts = deriveLondonPartsFromInstant(ms);
      startCountdown(ms, parts);
    } else {
      const ms = Date.now();
      const parts = deriveLondonPartsFromInstant(ms);
      startCountdown(ms, parts);
    }
  });

})();